import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6129f841")

_pushScopeId("data-v-6129f841")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.title,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = $event)),
    width: "570px",
    "close-on-click-modal": false,
    onClose: _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _ctx.loading,
        onClick: _ctx.onValidate
      }, {
        default: _withId(() => [
          _createTextVNode("确认" + _toDisplayString(_ctx.isType === 'edit' ? '修改' : '添加'), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withId(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.formData,
        ref: "refFrom",
        rules: _ctx.rules,
        "label-width": "130px",
        inline: false
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, { gutter: 30 }, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "设备厂商名称:",
                    prop: "deviceFactoryName"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.deviceFactoryName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.deviceFactoryName = $event)),
                        placeholder: "请输入",
                        maxlength: "16"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, {
                    label: "厂商唯一编号:",
                    prop: "deviceFactoryUuid"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.deviceFactoryUuid,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.deviceFactoryUuid = $event)),
                        placeholder: "请输入",
                        maxlength: "6",
                        disabled: _ctx.isType === 'edit'
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onClose"]))
})